module.exports = __webpack_public_path__ + "static/img/zfbshop.92462744.png";